var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00977,
    y: 4.74866,
    width: 14.5027,
    height: 14.5027,
    rx: 4.5,
    stroke: "#998A7B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5434 12.1066L16.5431 11.0414C16.543 10.5458 16.7877 10.0821 17.197 9.80252L19.6536 8.12416C20.6492 7.44396 21.9997 8.15693 21.9997 9.3627V14.6375C21.9997 15.8433 20.6492 16.5562 19.6536 15.876L17.197 14.1977C16.7877 13.9181 16.543 13.4544 16.5432 12.9588L16.5434 12.1066Z",
    stroke: "#998A7B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15039 12H11.3706",
    stroke: "#998A7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26074 14.1101L9.26074 9.88995",
    stroke: "#998A7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.cdb231ec3cde69a4c69169cac3d6f528.svg";
export { ForwardRef as ReactComponent };